import 'css-chunksrc/client/scenes/addIdentityProvider/form/azureForm/scopeSelect/styles.scss';export default {
  "scopeSelect": "_scopeSelect_1kbek_1",
  "input": "_input_1kbek_5",
  "name": "_name_1kbek_16",
  "iconBox": "_iconBox_1kbek_22",
  "icon": "_icon_1kbek_22",
  "open": "_open_1kbek_37",
  "listRoot": "_listRoot_1kbek_45",
  "list": "_list_1kbek_45",
  "item": "_item_1kbek_63"
};